import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

export interface SolicitudRadicadaDTO {
  idSolicitudesRadicadas: number;
  nroSolicitudTraslado: number;
  numeroContrato: string;
  tipoNovedad: string;
  subtipoNovedad: string;
  fechaCreacion: string;
  fechaUltimaGestion: string | null;
  creadoPor: string;
  estado: string;
}

@Injectable({
  providedIn: 'root',
})
export class SolicitudesRadicadasService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.SOLICITUDES_RADICADAS}`;

  constructor(private http: HttpClient) {}

  getSolicitudesRadicadas(numeroContrato: string): Observable<SolicitudRadicadaDTO[]> {
    const params = new HttpParams().set('numeroContrato', numeroContrato);
    return this.http.get<SolicitudRadicadaDTO[]>(this.apiUrl, { params });
  }
}
